import { findByKey } from './array'
import { date, datetime, minutetime, monthtime } from './datetime'

export default {}.install = function (Vue) {
  const filters = [
    {
      name: 'date',
      filter: date,
    },
    {
      name: 'datetime',
      filter: datetime,
    },
    {
      name: 'monthtime',
      filter: monthtime,
    },
    {
      name: 'minutetime',
      filter: minutetime,
    },
    {
      name: 'findByKey',
      filter: findByKey,
    },
  ]
  const filter = {}
  for (let i = 0; i < filters.length; i++) {
    const filer = filters[i]
    filter[filer.name] = filer.filter
  }
  Vue.config.globalProperties.$filters = filter
}
